import React from "react";

const Clefairy = ({ ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-0.5 -0.15 206.15 199.05"
      {...rest}
    >
      <g>
        <path
          fill="#f9dad9"
          d="M26.95 177.15 Q19.45 166.3 20.0 151.75 20.5 139.2 29.4 130.1 37.85 121.5 49.0 120.45 L90.8 171.0 Q87.75 179.5 78.0 185.8 66.1 193.55 51.45 191.6 35.5 189.55 26.95 177.15"
        />
        <path
          fill="#d7bdbc"
          d="M53.75 145.55 Q51.85 141.25 51.1 133.25 50.35 125.1 50.9 126.55 56.3 140.2 65.3 150.75 76.05 163.4 90.5 169.75 88.65 177.5 80.1 184.2 72.5 190.05 65.75 191.1 45.85 194.15 35.55 184.85 41.7 187.75 46.75 188.4 51.4 189.0 54.45 187.65 57.1 186.4 57.8 182.8 58.6 178.8 55.55 176.15 L48.45 169.85 Q43.05 164.4 42.1 160.65 44.7 163.85 48.4 165.8 52.05 167.75 55.95 168.0 59.6 168.2 63.9 166.3 68.1 164.5 67.05 163.7 64.2 161.6 60.2 156.25 55.95 150.55 53.75 145.55"
        />
        <path
          fill="#0d131a"
          d="M50.05 122.55 Q33.4 124.05 25.75 136.55 18.9 147.75 21.8 162.2 24.55 175.5 34.25 183.15 42.95 190.0 54.85 190.6 66.25 191.25 75.75 185.95 85.75 180.35 89.2 170.4 90.1 167.75 91.2 168.5 92.3 169.2 91.3 171.4 86.25 182.55 75.25 188.25 64.95 193.6 53.05 192.5 40.95 191.4 32.1 184.05 22.45 176.1 19.85 162.95 16.0 143.5 26.9 131.25 31.45 126.15 37.7 123.6 43.7 121.1 49.55 121.55 49.85 121.95 49.95 121.75 L50.05 122.55"
        />
        <path
          fill="#0d131a"
          d="M42.35 142.3 Q43.75 141.2 44.3 141.35 44.8 141.5 44.0 142.4 39.75 147.05 41.85 155.35 44.05 164.2 51.8 166.3 57.3 167.75 62.7 165.45 68.3 163.1 70.9 157.85 71.6 156.45 72.2 157.1 72.8 157.75 72.3 158.75 69.25 165.05 62.25 167.65 56.05 169.9 51.0 168.1 41.0 164.55 39.65 154.25 39.1 150.35 40.05 146.75 40.9 143.45 42.35 142.3"
        />
        <path
          fill="#0d131a"
          d="M47.35 96.75 Q47.9 97.05 48.15 97.7 L59.55 125.6 Q56.65 139.25 48.3 142.2 L42.4 142.6 Q37.95 142.15 35.0 140.25 26.6 134.85 35.6 121.2 24.75 115.8 19.85 109.95 15.8 105.1 16.3 100.6 17.05 93.95 26.45 92.2 36.55 90.35 47.35 96.75"
        />
        <path
          fill="#f9dad9"
          d="M33.05 93.8 Q39.15 94.1 44.7 97.25 L57.35 129.0 Q56.0 133.1 53.45 136.05 50.85 139.05 47.55 140.2 41.65 142.25 35.75 138.25 34.4 137.3 33.8 136.15 33.3 135.2 33.15 134.35 32.55 131.1 34.6 126.45 L36.85 122.35 Q37.75 121.1 37.6 120.6 37.45 120.1 36.05 119.45 28.75 116.1 23.4 110.65 18.2 105.4 18.55 102.2 19.1 97.8 23.75 95.45 27.7 93.55 33.05 93.8"
        />
        <path
          fill="#d7bdbc"
          d="M38.05 98.85 L38.0 94.55 Q41.6 95.55 44.7 97.25 L57.35 129.0 Q55.45 134.75 51.3 138.05 45.55 130.95 42.1 120.95 38.55 110.55 38.05 98.85"
        />
        <path
          fill="#f9dad9"
          d="M164.95 54.25 Q168.25 57.9 169.75 60.45 L183.15 65.0 Q196.7 69.5 198.05 70.75 199.95 72.45 200.15 76.15 200.35 79.65 199.05 81.35 197.45 83.4 192.3 85.35 187.95 87.05 184.0 87.65 186.95 96.45 186.85 107.45 186.75 118.7 183.5 129.55 175.95 154.65 156.85 164.8 140.85 173.3 122.15 174.75 105.2 176.05 92.3 171.35 75.75 163.35 64.3 149.3 53.9 136.5 49.0 120.45 47.0 116.3 45.35 106.45 43.8 97.55 44.1 95.3 31.15 91.0 14.4 71.75 7.85 64.25 3.9 57.85 0.0 51.5 0.95 50.05 6.85 41.2 30.85 35.8 51.6 31.15 65.65 32.3 67.95 20.4 78.2 11.65 86.75 4.4 97.5 1.65 104.7 -0.15 113.0 1.4 125.15 3.65 133.4 12.85 141.7 8.85 148.2 7.25 155.45 5.4 157.2 7.5 162.3 13.75 162.35 28.8 162.4 42.15 159.35 49.05 161.55 50.5 164.95 54.25"
        />
        <path
          fill="#ed8599"
          d="M130.0 72.05 Q132.75 70.85 134.4 70.85 138.3 70.85 140.75 72.75 140.3 75.25 139.7 75.85 137.85 77.6 134.25 75.65 131.25 74.05 130.0 72.05"
        />
        <path
          fill="#922f00"
          d="M140.75 72.75 Q137.75 70.8 134.0 70.8 133.8 70.8 133.55 70.45 133.35 70.1 133.1 70.1 138.4 67.2 138.95 66.55 139.6 67.25 140.15 69.2 140.65 71.0 140.75 72.75"
        />
        <path
          fill="#0d131a"
          d="M130.4 72.4 Q129.9 71.75 130.25 71.6 L132.9 70.45 Q137.05 69.95 140.75 72.3 L140.75 73.45 Q136.1 69.95 130.4 72.4"
        />
        <path
          fill="#ed85ad"
          d="M119.9 76.1 Q120.8 76.05 121.3 76.95 121.75 77.7 121.55 78.35 121.3 79.15 120.5 79.85 L118.05 81.45 Q115.35 83.0 113.6 82.95 112.7 82.95 112.3 82.1 111.95 81.25 112.35 80.4 113.1 78.85 115.8 77.4 118.2 76.1 119.9 76.1"
        />
        <path
          fill="#ed85ad"
          d="M154.75 56.55 Q155.85 58.0 152.8 60.45 151.65 61.4 150.4 61.55 149.15 61.65 148.7 60.95 147.9 59.65 150.75 57.5 152.35 56.25 153.3 56.0 154.2 55.8 154.75 56.55"
        />
        <path
          fill="#524423"
          d="M37.25 39.1 Q41.15 42.25 44.05 46.0 47.75 50.9 49.8 56.1 51.85 61.3 50.8 62.9 L41.25 63.25 Q33.15 62.3 23.15 59.8 12.6 57.15 6.55 54.4 -0.4 51.25 1.4 49.15 5.7 44.1 17.7 39.5 28.75 35.2 32.25 35.95 33.9 36.35 37.25 39.1"
        />
        <path
          fill="#524423"
          d="M140.25 9.35 Q143.7 7.7 148.05 6.8 L155.1 6.6 Q157.25 7.3 159.45 13.0 161.45 18.3 161.3 21.2 158.6 17.75 150.85 13.5 143.35 9.4 140.25 9.35"
        />
        <path
          fill="#d7bdbc"
          d="M100.4 41.35 Q99.4 40.35 99.2 37.65 99.0 34.85 99.9 32.05 102.2 24.6 109.45 23.9 116.4 23.25 120.25 28.85 122.15 31.65 122.15 33.95 118.75 30.45 115.1 29.2 112.2 28.2 109.9 28.75 103.8 30.2 101.5 35.95 100.35 38.8 100.4 41.35"
        />
        <path
          fill="#d7bdbc"
          d="M108.35 52.8 Q113.8 55.55 119.25 54.8 122.95 54.3 126.75 52.35 132.4 49.45 135.3 44.35 135.3 46.65 133.8 49.95 132.05 53.75 129.2 56.45 124.3 60.9 117.9 60.55 112.15 60.25 107.3 55.9 103.5 52.5 102.2 48.85 L108.35 52.8"
        />
        <path
          fill="#d7bdbc"
          d="M68.35 75.35 Q63.6 87.05 66.95 105.8 69.95 122.85 76.6 132.35 85.1 144.6 99.3 152.5 112.45 159.8 127.65 161.95 142.45 164.0 154.95 160.6 167.9 157.05 174.55 148.5 161.25 166.85 135.3 172.6 112.7 177.65 94.55 171.35 74.9 164.5 61.35 144.75 46.65 123.3 44.45 93.7 44.05 88.1 54.3 81.15 63.95 74.55 68.35 75.35"
        />
        <path
          fill="#d7bdbc"
          d="M155.65 174.85 Q147.25 186.35 140.75 189.6 137.95 191.05 134.25 191.35 129.6 191.75 126.4 189.8 124.4 188.6 121.55 184.2 118.55 179.55 117.3 175.35 126.4 175.35 138.95 171.85 153.85 167.7 163.6 160.9 163.15 164.5 155.65 174.85"
        />
        <path
          fill="#d7bdbc"
          d="M90.75 73.4 Q94.3 74.1 98.85 85.85 103.25 97.1 102.7 102.0 102.35 105.25 99.25 105.85 96.15 106.4 95.95 102.6 95.75 98.65 93.25 89.35 90.8 80.15 88.85 75.75 88.45 74.85 89.4 74.05 90.2 73.3 90.75 73.4"
        />
        <path
          fill="#d7bdbc"
          d="M180.6 78.45 Q185.35 77.95 192.1 76.4 198.4 74.95 199.8 74.15 201.1 78.65 199.0 81.6 197.95 83.1 191.8 85.5 185.9 87.75 184.15 87.6 182.75 82.0 180.6 78.45"
        />
        <path
          fill="#ffffff"
          d="M198.85 82.35 Q200.4 81.3 200.35 78.3 200.25 76.0 199.55 74.45 201.25 75.2 203.1 76.8 205.05 78.5 204.75 79.25 204.4 80.15 202.55 81.15 200.65 82.25 198.85 82.35"
        />
        <path
          fill="#ffffff"
          d="M127.45 191.45 L129.9 191.55 Q133.5 192.1 136.2 191.55 138.0 191.2 140.05 190.1 141.45 189.35 141.9 189.6 142.6 190.05 141.15 193.15 139.6 196.45 137.65 197.15 136.15 197.7 131.95 195.2 127.9 192.8 127.45 191.45"
        />
        <path
          fill="#0d131a"
          d="M40.85 33.0 Q60.3 30.15 71.3 32.9 73.85 33.55 73.8 34.05 L71.5 34.2 Q52.75 31.55 30.95 36.8 9.9 41.85 3.7 49.6 2.05 51.65 5.95 58.15 9.55 64.05 16.45 71.7 32.5 89.55 43.1 93.5 45.35 94.35 44.95 95.3 L42.2 95.25 Q31.4 90.55 19.9 78.95 11.35 70.35 4.05 59.75 -0.2 53.55 0.05 50.85 0.3 47.8 5.95 44.25 19.25 36.15 40.85 33.0"
        />
        <path
          fill="#0d131a"
          d="M138.75 24.3 Q142.4 43.35 127.7 52.7 120.9 57.05 112.7 55.55 104.6 54.05 101.4 48.15 98.1 41.95 100.55 35.85 102.8 30.2 107.95 28.45 115.2 26.05 119.85 30.4 124.1 34.3 122.6 39.2 121.65 42.15 121.0 41.5 120.3 40.85 120.85 38.7 122.1 33.75 117.25 31.05 112.45 28.4 107.75 30.95 103.4 33.3 102.0 37.5 100.55 41.95 103.15 46.85 106.15 52.4 113.15 53.8 120.25 55.2 126.7 51.35 134.65 46.65 137.1 38.0 139.4 29.85 136.15 21.35 132.8 12.6 125.05 7.35 116.45 1.5 105.0 1.95 92.05 2.4 81.15 10.75 69.7 19.55 66.3 32.85 L65.35 33.2 Q64.45 33.25 64.6 32.75 68.7 17.5 80.8 8.45 92.05 0.0 105.6 0.0 119.2 0.0 128.6 7.8 136.9 14.65 138.75 24.3"
        />
        <path
          fill="#0d131a"
          d="M156.25 6.1 Q160.3 8.7 162.25 20.8 164.55 35.25 159.9 49.4 159.45 50.8 158.85 49.85 158.25 48.95 158.55 47.8 162.4 35.05 160.15 21.6 158.2 10.05 154.7 8.3 152.5 7.25 145.75 9.05 139.1 10.85 133.95 13.8 L132.3 13.7 Q131.75 13.0 132.35 12.6 138.3 8.85 146.2 6.75 154.0 4.7 156.25 6.1"
        />
        <path
          fill="#0d131a"
          d="M17.0 74.5 Q9.15 66.25 4.25 58.45 -0.5 50.9 1.65 50.65 21.5 47.85 48.6 61.0 58.65 65.9 64.55 70.6 70.35 75.25 67.6 76.0 62.4 77.4 54.35 84.8 47.8 90.85 44.85 95.2 38.95 93.75 32.2 88.6 26.05 83.95 17.0 74.5"
        />
        <path
          fill="#0d131a"
          d="M110.65 63.45 Q111.45 63.1 112.7 63.95 113.9 64.8 114.85 66.35 115.95 68.15 116.2 69.55 116.45 70.95 115.6 71.4 114.85 71.75 113.6 70.7 L111.65 68.45 Q108.85 64.25 110.65 63.45"
        />
        <path
          fill="#0d131a"
          d="M118.9 72.4 L119.65 71.7 120.05 70.8 Q120.85 68.75 119.05 66.5 118.5 65.8 119.05 65.2 119.6 64.6 120.55 65.55 121.6 66.6 121.95 68.4 122.25 70.05 121.8 71.4 L120.95 73.0 119.65 74.0 Q118.85 74.45 118.45 73.8 118.05 73.1 118.9 72.4"
        />
        <path
          fill="#ffffff"
          d="M112.8 64.9 Q113.25 65.55 113.3 66.15 113.4 66.75 113.05 67.0 L112.15 66.95 Q111.6 66.7 111.15 66.05 110.7 65.45 110.65 64.85 110.55 64.25 110.9 64.0 111.25 63.75 111.8 64.0 112.35 64.25 112.8 64.9"
        />
        <path
          fill="#0d131a"
          d="M134.6 51.75 L136.6 51.7 Q137.6 52.35 138.6 53.75 139.5 54.9 139.8 56.0 140.25 57.45 139.4 58.0 138.45 58.65 136.05 55.65 133.7 52.75 134.6 51.75"
        />
        <path
          fill="#0d131a"
          d="M142.4 52.3 Q141.95 51.7 142.55 51.15 143.15 50.6 143.8 51.3 L145.7 53.75 Q146.6 55.4 146.55 56.65 146.45 59.3 144.7 60.25 143.85 60.65 143.5 59.95 143.1 59.25 143.6 58.85 144.85 57.95 144.7 56.35 144.6 55.15 143.9 54.15 L142.4 52.3"
        />
        <path
          fill="#ffffff"
          d="M135.5 53.6 Q134.6 52.35 135.3 51.85 L136.05 51.9 136.9 52.65 137.3 53.7 137.1 54.4 Q136.8 54.65 136.35 54.4 L135.5 53.6"
        />
        <path
          fill="#0d131a"
          d="M140.0 72.8 Q140.15 71.6 139.55 69.6 L138.7 67.35 Q135.9 70.15 131.1 72.0 L132.55 73.55 Q134.15 75.15 135.05 75.5 137.35 76.45 138.65 75.55 139.85 74.8 140.0 72.8 M128.9 72.15 Q128.5 71.35 129.4 70.95 132.25 69.85 135.35 68.0 138.55 66.1 139.65 64.8 140.15 64.25 140.4 64.6 140.6 64.95 140.25 65.5 L139.45 66.55 Q140.15 67.35 140.7 69.4 141.3 71.45 141.25 73.05 141.1 76.05 139.1 77.05 137.15 78.0 134.4 76.7 133.2 76.15 131.35 74.65 129.45 73.05 128.9 72.15"
        />
        <path
          fill="#0d131a"
          d="M98.1 80.95 Q102.7 90.25 103.15 100.0 103.25 102.75 102.5 103.15 101.75 103.55 101.45 100.45 100.9 93.3 97.1 84.15 93.25 74.85 89.85 72.95 86.8 71.25 84.0 72.85 81.7 74.15 80.25 77.1 79.3 79.15 78.25 87.8 77.45 94.6 77.3 97.9 77.2 100.6 76.5 100.6 75.8 100.6 75.5 97.55 75.2 94.2 76.3 86.6 77.5 78.6 79.0 75.5 81.3 70.85 85.2 70.05 88.3 69.45 90.9 71.15 94.3 73.3 98.1 80.95"
        />
        <path
          fill="#0d131a"
          d="M86.4 73.05 Q86.4 73.65 83.15 74.65 79.9 75.6 79.55 75.1 78.5 73.7 78.8 69.75 79.1 65.65 80.65 65.15 82.05 64.75 84.2 67.3 86.5 70.05 86.4 73.05"
        />
        <path
          fill="#ffffff"
          d="M82.7 72.65 L80.5 72.75 Q79.95 71.65 80.25 69.3 80.5 66.95 81.05 66.85 82.1 66.7 83.5 69.2 84.9 71.75 82.7 72.65"
        />
        <path
          fill="#0d131a"
          d="M89.6 65.55 Q91.7 65.8 92.45 69.15 93.15 72.15 92.35 73.45 92.1 73.9 91.75 73.25 91.45 72.6 91.5 72.1 91.65 70.6 91.0 69.05 90.35 67.45 89.45 67.4 88.4 67.35 87.6 68.45 87.0 69.2 86.75 70.2 L86.1 70.85 Q85.5 71.05 85.6 70.1 85.7 68.7 86.95 67.1 88.3 65.4 89.6 65.55"
        />
        <path
          fill="#0d131a"
          d="M84.05 72.7 Q85.0 71.2 86.7 70.0 88.8 68.5 90.1 69.2 90.9 69.6 91.2 71.5 91.5 73.3 91.1 74.95 90.75 76.35 89.15 77.1 87.4 77.85 85.7 77.15 84.25 76.5 83.7 75.55 83.0 74.25 84.05 72.7"
        />
        <path
          fill="#ffffff"
          d="M85.4 72.95 L87.3 71.35 Q88.75 70.4 89.35 70.65 90.45 71.15 89.85 73.55 88.9 76.7 86.2 75.9 85.45 75.7 85.05 74.95 84.5 74.05 85.4 72.95"
        />
        <path
          fill="#0d131a"
          d="M168.75 60.0 Q167.75 58.95 168.25 59.0 L181.8 63.8 196.55 69.05 Q199.55 69.9 200.6 74.95 201.65 79.75 200.0 81.6 197.95 83.95 191.15 86.55 184.75 88.95 183.45 88.45 182.8 88.15 182.65 87.45 182.5 86.75 183.2 86.7 186.95 86.45 192.75 83.95 198.0 81.65 198.75 80.55 200.15 78.4 199.15 74.65 198.1 70.9 195.95 70.25 172.4 62.3 170.45 61.35 L168.75 60.0"
        />
        <path
          fill="#0d131a"
          d="M191.85 72.4 L193.05 72.35 Q195.35 72.65 196.9 73.7 198.25 74.65 198.35 75.65 198.5 77.25 196.4 78.85 194.65 80.2 193.45 80.35 190.75 80.65 193.3 79.15 L195.35 77.7 Q196.5 76.7 196.65 75.95 196.85 75.05 195.55 74.3 L193.05 73.2 191.85 72.4"
        />
        <path
          fill="#0d131a"
          d="M195.05 68.95 Q196.0 67.55 199.35 67.2 202.7 66.8 203.6 68.2 204.3 69.3 202.55 72.0 200.8 74.65 199.2 75.2 197.85 75.65 195.95 73.05 194.0 70.4 195.05 68.95"
        />
        <path
          fill="#ffffff"
          d="M196.2 70.4 Q196.55 68.6 199.75 68.4 203.0 68.2 202.55 69.35 202.05 70.65 200.75 72.15 199.3 73.95 198.55 73.6 L196.85 72.3 Q196.0 71.3 196.2 70.4"
        />
        <path
          fill="#0d131a"
          d="M199.05 81.35 Q199.85 81.45 201.55 80.8 203.3 80.1 203.85 79.5 204.35 79.0 202.5 77.5 L199.9 75.8 199.5 74.9 Q199.25 74.1 199.8 74.15 201.25 74.25 203.4 76.15 205.65 78.15 205.3 79.55 204.85 81.25 201.4 82.4 198.3 83.4 197.1 83.0 196.25 82.75 197.4 82.0 198.5 81.3 199.05 81.35"
        />
        <path
          fill="#0d131a"
          d="M162.85 161.1 Q163.5 159.15 164.95 158.05 166.45 156.9 165.65 159.4 162.6 169.1 153.2 179.7 145.2 188.75 140.15 191.0 135.8 192.95 131.45 192.5 126.35 191.95 123.35 188.15 117.05 180.05 116.4 177.15 116.35 176.65 117.25 175.95 118.15 175.25 118.4 175.4 L120.05 179.15 Q122.15 183.55 124.55 186.5 127.3 189.85 131.95 190.4 136.05 190.85 139.35 189.15 146.65 185.25 154.35 175.4 161.0 166.85 162.85 161.1"
        />
        <path
          fill="#0d131a"
          d="M140.3 191.05 Q140.25 189.65 141.55 188.95 142.8 188.25 142.9 189.3 143.1 192.25 141.5 194.95 139.95 197.4 138.0 198.0 135.15 198.9 130.05 195.15 124.95 191.45 124.4 188.3 124.25 187.65 125.95 189.2 L128.1 191.35 Q129.45 192.95 132.6 194.85 136.15 196.95 137.55 196.35 138.95 195.7 139.75 193.95 140.45 192.45 140.3 191.05"
        />
        <path
          fill="#0d131a"
          d="M33.25 35.25 Q40.75 38.9 47.35 49.7 53.25 59.5 52.6 63.75 52.05 67.55 50.35 63.2 49.85 56.4 43.7 47.4 37.2 37.9 30.8 36.2 28.55 35.6 30.6 35.3 L33.25 35.25"
        />
        <path
          fill="#0d131a"
          d="M161.45 22.45 Q157.95 18.25 151.4 14.55 144.55 10.65 139.0 10.0 138.4 9.9 139.25 9.4 140.1 8.85 141.0 9.0 146.15 9.85 151.9 12.85 158.2 16.1 161.15 19.95 162.55 21.75 162.25 22.45 161.95 23.1 161.45 22.45"
        />
        <path
          fill="#0d131a"
          d="M182.2 136.8 Q171.6 161.2 147.5 170.45 126.15 178.65 99.05 173.6 88.6 171.7 78.6 164.55 68.45 157.3 60.6 146.0 42.95 120.6 43.25 86.85 43.3 82.5 44.1 84.0 44.95 85.45 44.95 88.45 44.95 114.85 58.7 138.6 74.35 165.65 99.65 171.6 122.75 177.05 144.9 168.95 170.75 159.55 180.4 135.4 192.8 104.4 176.0 72.95 169.2 60.2 158.75 50.15 149.05 40.85 139.2 36.6 138.75 36.4 138.5 35.1 138.2 33.8 139.45 34.45 169.5 49.9 181.85 80.15 187.55 94.25 187.75 108.75 187.9 123.65 182.2 136.8"
        />
        <path
          fill="#0d131a"
          d="M94.15 135.1 Q99.95 128.65 106.7 128.95 115.9 129.35 121.65 137.25 126.9 144.45 127.45 154.95 128.15 167.7 122.45 174.05 117.85 179.2 109.65 179.7 98.0 180.45 91.85 172.4 85.75 164.4 87.3 150.8 88.3 141.65 94.15 135.1"
        />
        <path
          fill="#f9dad9"
          d="M96.6 135.15 Q101.5 129.8 105.55 130.05 115.1 130.7 120.45 139.2 125.15 146.65 125.2 157.1 L125.15 159.6 Q125.1 151.95 120.4 147.75 116.75 144.5 112.1 144.3 105.9 144.0 100.95 149.9 96.25 155.45 95.55 162.6 94.85 170.9 98.4 175.45 93.45 172.4 91.15 166.15 89.15 160.7 89.5 154.05 90.2 142.15 96.6 135.15"
        />
        <path
          fill="#d7bdbc"
          d="M112.1 144.3 Q116.75 144.5 120.4 147.75 125.1 151.95 125.15 159.6 124.6 167.95 120.25 172.95 115.9 177.95 109.2 178.05 102.8 178.1 98.4 175.45 94.85 170.9 95.55 162.6 96.25 155.45 100.95 149.9 105.9 144.0 112.1 144.3"
        />
        <path
          fill="#0d131a"
          d="M99.35 138.1 Q97.35 136.0 100.3 131.6 103.35 127.0 107.95 126.65 111.95 126.4 115.6 129.55 119.3 132.75 118.55 136.15 117.75 139.7 110.35 140.7 102.8 141.7 99.35 138.1"
        />
        <path
          fill="#ffffff"
          d="M101.1 136.5 Q99.9 135.2 102.55 132.15 105.3 129.0 108.3 128.8 110.9 128.6 113.9 130.95 116.95 133.35 116.45 135.5 115.95 137.75 109.7 138.3 103.3 138.85 101.1 136.5"
        />
        <path
          fill="#0d131a"
          d="M138.75 66.15 L139.5 65.35 139.6 66.15 Q140.4 67.25 140.35 68.35 140.3 69.15 139.9 69.55 139.65 69.85 138.7 69.55 137.7 69.25 136.6 68.5 L136.0 68.1 138.75 66.15"
        />
        <path
          fill="#ffffff"
          d="M139.2 67.0 L139.5 68.1 139.3 68.8 138.8 68.75 137.8 68.05 139.2 67.0"
        />
      </g>
    </svg>
  );
};

export default Clefairy;
